import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Datetime from 'components/Datetime';
import { Translate } from 'react-redux-i18n';
import { NavLink } from 'react-router-dom';
import { EDIT_COUPON } from 'constants/routes';
import Cell from 'components/ListView/Cell';
import buildActualPath from 'helpers/build-actual-path';

class ListRow extends Component {
    static propTypes = {
        columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
        data: PropTypes.shape({
            id: PropTypes.string.isRequired,
            coupon_code: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            status: PropTypes.number.isRequired,
            discount_type: PropTypes.number.isRequired,
            discount_value: PropTypes.number.isRequired,
            convert_from: PropTypes.string.isRequired,
            convert_to: PropTypes.string.isRequired,
            remaining_quota: PropTypes.number.isRequired,
        }).isRequired,
    };

    renderField({ data, name, width, minWidth }) {
        let el;

        switch (name) {
        case 'title':
            el = (
                <NavLink to={ buildActualPath(EDIT_COUPON, { couponId: data.id }) }>{ data.title }</NavLink>
            );
            break;
        case 'coupon_code':
            el = <span className="coupon-code-wrapper">{ data.coupon_code }</span>;
            break;
        case 'status':
            el = <Translate value={ `coupon.status_${ data[name] }` } />;
            break;
        case 'discount_type':
            el = <Translate value={ `coupon.type_${ data[name] }` } />;
            break;
        case 'discount_value':
            el = (
                <React.Fragment>
                    <span className="discount-value">{ data.discount_value }</span>
                    <Translate value={ `coupon.discount_${ data.discount_type }` } />
                </React.Fragment>
            );
            break;
        case 'convert_from':
        case 'convert_to':
            el = <Datetime time={ data[name] } />;
            break;
        default:
            el = data[name];
            break;
        }

        return (
            <Cell
                key={ `${ data.id }-${ name }` }
                name={ name }
                style={ {
                    width,
                } }
            >
                { el }
            </Cell>
        );
    }

    render() {
        const { columns, data } = this.props;

        return columns.map(({ key, width }, i) => {
            return this.renderField({ data, width, name: key, });
        });
    }
}

export default ListRow;
